<script setup lang="ts">

</script>

<template>
  <div class="logo__text mt-3 text-overline text-grey-darken-1">
    <div>Car Detailing</div>
    <strong>Pixel Restoration</strong>
  </div>
</template>

<style scoped lang="scss">
.logo__text {
  strong {
    display: block;
    margin-top: 2px;
    font-size: 16px;
    color: white;
    opacity: 0.5;
  }
}
</style>